const React = require("react");
const Ripple = require("../../../../../../../dumb/Ripple");
const DropIcon = require("../../../../../../../icons/Drop");

module.exports = ({value, open, error, onClick}) => {
  return (
    <>
      <div
        className={
          `w100vw h100vh fixed sl0 st0 z-1 z1001.open`
          + (open ? ' open' : '')
        }
        onClick={onClick}
      />
      <Ripple
        className={
          `w h52 rlv layoutRow jcSB aiC pt14 ph20 pb17 r8 b1.5 bs bcEDEEF0 bcF44336.error z1001.open`
          + (open ? ' open' : '')
          + (error ? ' error' : '')
        }
        onClick={onClick}
      >
        <div>
          {value}
        </div>
        <div className={`rlv sr0-i>svg fill0>path rx180.open dn` + (open ? ' open' : '')}>
          <DropIcon />
        </div>
      </Ripple>
    </>
  )
}
